import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
  Box,
  Typography,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  FormLabel,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import { isValidEmail } from "./utils";

const EmailReportDialog = ({
  open,
  onClose,
  onCancel,
  onSend,
  emailAddress,
  setEmailAddress,
  emailSending,
  fetchingMongoData,
  emailDataSource,
  setEmailDataSource,
  emailStartDate,
  setEmailStartDate,
  emailEndDate,
  setEmailEndDate,
  scannedCount,
}) => (
  <Dialog
    open={open}
    onClose={onClose}
    PaperProps={{
      sx: { borderRadius: 3, direction: "ltr", minWidth: 300, p: 0.5 },
    }}
  >
    <DialogTitle
      sx={{
        fontWeight: 700,
        fontSize: "1.05rem",
        pb: 0.5,
        display: "flex",
        alignItems: "center",
        gap: 1,
      }}
    >
      <EmailIcon sx={{ color: "#0563B0", fontSize: 22 }} />
      שלח דוח במייל
    </DialogTitle>
    <DialogContent sx={{ pt: "12px !important" }}>
      <FormControl component="fieldset" sx={{ mb: 2, width: "100%" }}>
        <FormLabel
          component="legend"
          sx={{ fontSize: "0.9rem", fontWeight: 600, mb: 1, color: "#333" }}
        >
          מקור הנתונים
        </FormLabel>
        <RadioGroup
          value={emailDataSource}
          onChange={(e) => setEmailDataSource(e.target.value)}
        >
          <FormControlLabel
            value="scanned"
            control={<Radio />}
            label={`פריטים סרוקים נוכחיים (${scannedCount})`}
            sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.88rem" } }}
          />
          <FormControlLabel
            value="mongodb"
            control={<Radio />}
            label="נתונים מהמערכת לפי טווח תאריכים"
            sx={{ "& .MuiFormControlLabel-label": { fontSize: "0.88rem" } }}
          />
        </RadioGroup>
      </FormControl>

      {emailDataSource === "mongodb" && (
        <Box sx={{ mb: 2, p: 2, bgcolor: "#f5f5f5", borderRadius: 2 }}>
          <Typography sx={{ fontSize: "0.85rem", fontWeight: 600, mb: 1.5, color: "#555" }}>
            בחר טווח תאריכים
          </Typography>
          <Box sx={{ display: "flex", gap: 1.5, flexDirection: "column" }}>
            <TextField
              label="מתאריך"
              type="date"
              value={emailStartDate}
              onChange={(e) => setEmailStartDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              size="small"
              fullWidth
              disabled={fetchingMongoData}
              sx={{ bgcolor: "#fff" }}
            />
            <TextField
              label="עד תאריך"
              type="date"
              value={emailEndDate}
              onChange={(e) => setEmailEndDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
              size="small"
              fullWidth
              disabled={fetchingMongoData}
              sx={{ bgcolor: "#fff" }}
            />
          </Box>
          {fetchingMongoData && (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1.5 }}>
              <CircularProgress size={16} />
              <Typography sx={{ fontSize: "0.8rem", color: "#666" }}>
                טוען נתונים...
              </Typography>
            </Box>
          )}
        </Box>
      )}

      <TextField
        autoFocus={emailDataSource === "scanned"}
        fullWidth
        label="כתובת מייל"
        placeholder="example@domain.com"
        type="email"
        value={emailAddress}
        onChange={(e) => setEmailAddress(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && onSend()}
        disabled={emailSending || fetchingMongoData}
        error={emailAddress.length > 0 && !isValidEmail(emailAddress)}
        helperText={
          emailAddress.length > 0 && !isValidEmail(emailAddress)
            ? "כתובת מייל לא תקינה"
            : " "
        }
        sx={{ direction: "ltr" }}
        size="small"
      />
    </DialogContent>
    <DialogActions sx={{ px: 2, pb: 2, gap: 1 }}>
      <Button
        variant="outlined"
        onClick={onCancel}
        disabled={emailSending || fetchingMongoData}
        sx={{ flex: 1, borderRadius: 2, fontWeight: 600 }}
      >
        ביטול
      </Button>
      <Button
        variant="contained"
        onClick={onSend}
        disabled={
          emailSending ||
          fetchingMongoData ||
          !isValidEmail(emailAddress) ||
          (emailDataSource === "mongodb" && (!emailStartDate || !emailEndDate))
        }
        startIcon={
          emailSending || fetchingMongoData ? (
            <CircularProgress size={16} sx={{ color: "#fff" }} />
          ) : (
            <EmailIcon />
          )
        }
        sx={{
          flex: 1,
          borderRadius: 2,
          fontWeight: 600,
          bgcolor: "#0563B0",
          "&:hover": { bgcolor: "#044a8a" },
          "&.Mui-disabled": { bgcolor: "#90b8d8", color: "#fff" },
        }}
      >
        {emailSending || fetchingMongoData ? "טוען..." : "שלח"}
      </Button>
    </DialogActions>
  </Dialog>
);

export default EmailReportDialog;
